import { FileInfo } from './file-info';
import { FileSource } from '@enums/file-source.enum';

export class FileImport {
    type: FileSource;
    files: FileInfo[];

    isClientImport: boolean;

    // Import provider
    providerCode?: string;
    fileTypeCode?: string;

    // Import simulation
    partitioningCode?: string;

    constructor(type: FileSource, files: FileInfo[], isClientImport: boolean = false, codes: { provider?: string, fileType?: string, partitioning?: string, }) {
        this.type = type;
        this.files = files;
        this.isClientImport = isClientImport;

        if(type === FileSource.provider) {
            this.providerCode = codes.provider || null;
            this.fileTypeCode = codes.fileType || null;
        } else {
            this.partitioningCode = codes.partitioning || null;
        }
    }
}
